import { Button, Link, YouTube } from '@sparemin/blockhead';
import InfoCard from 'components/InfoCard';
import React from 'react';
import { COMING_SOON_BADGE, WHAT_IS_PODCAST_PROMO_URL } from './constants';
import * as S from './styles';
import { PlacementCardProps } from './types';

const YoutubeCard: React.FC<PlacementCardProps> = ({
  isComingSoon,
  onPress,
}) => (
  <S.Card $isDisabled={isComingSoon}>
    <S.YoutubeCardContainer>
      <InfoCard.Image>
        <S.YoutubeLogoTile>
          <YouTube width="48px" height="33px" />
        </S.YoutubeLogoTile>
      </InfoCard.Image>

      <InfoCard.Contents
        badge={isComingSoon ? COMING_SOON_BADGE : 'Better targeting'}
        heading="On YouTube"
        subheading={
          <>
            Your clip runs as a video ad in front of YouTube viewers, so it
            reaches people already watching. Ideal for growing a video-first
            show (
            <Link href={WHAT_IS_PODCAST_PROMO_URL} target="_blank">
              learn more
            </Link>
            ).
          </>
        }
      >
        <S.ButtonContainer>
          <Button fluid isDisabled={isComingSoon} onPress={onPress}>
            Select this option
          </Button>
        </S.ButtonContainer>
      </InfoCard.Contents>
    </S.YoutubeCardContainer>
  </S.Card>
);

export default YoutubeCard;
